import { render } from "./enrichment-search.vue?vue&type=template&id=13b2aedd"
import script from "./enrichment-search.vue?vue&type=script&lang=js"
export * from "./enrichment-search.vue?vue&type=script&lang=js"

import "./enrichment-search.vue?vue&type=style&index=0&id=13b2aedd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__